/**
 * What *Delete selected* says before it deletes (N7, 2026-09-29).
 *
 * It deleted at the first press — every selected upload, its stored file and what ProGST read
 * from it — with no question asked, though nothing can bring them back
 * (`api/intake.py::delete_document` removes the row and both stored objects). The question now
 * names the files and says what goes and what stays, before anything is sent.
 */

/** How many file names the question lists before it says "and N more". */
export const NAMES_SHOWN = 5

export interface DeleteQuestion {
  title: string
  names: string[]
  more: number
  consequence: string
  confirm: string
  /** The answer that deletes nothing (N34): "Keep it" for one upload, never "Keep them". */
  keep: string
}

export function deleteQuestion(names: string[]): DeleteQuestion {
  const n = names.length
  const noun = n === 1 ? 'upload' : 'uploads'
  return {
    title: `Delete ${n} ${noun}?`,
    names: names.slice(0, NAMES_SHOWN),
    more: Math.max(0, n - NAMES_SHOWN),
    consequence:
      'Each file and what ProGST read from it are removed, and cannot be brought back. ' +
      'Edits made to its rows are kept. A file already booked into a return is refused — ' +
      'reject it with a reason instead, so the record says who removed it and why.',
    confirm: n === 1 ? 'Delete it' : `Delete ${n} uploads`,
    keep: n === 1 ? 'Keep it' : 'Keep them',
  }
}
